import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';

// @ts-ignore Dont know wtf is going on here.. But this works fine.
const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);

export default DatePicker;
